<template>
  <generic-content
      :isDownloadable="true"
      :isLinkable="false"
      :isEditable="isEditable"
      :isPayable="isPayable"
      :isDeletable="isDeletable"
      @click="isParentMethodPriority?$emit('click'):download()"
      @download="download"
      @toRoute="isParentMethodPriority?$emit('toRoute'):''"
      @edit="$emit('edit')"
      @pay="$emit('pay')"
      @delete="$emit('delete')"
  >
    <template #iconContent>
      <b-avatar
          size="32"
          :variant="'light-'+iconStatus.variant"
          class="my-auto"
      >
        <icon
            :icon="iconStatus.icon"
        />
      </b-avatar>
    </template>

    <template #bodyContent>
      <h6 class="transaction-title text-truncate">
        {{ outgoingInvoice.customerCompany ? outgoingInvoice.customerCompany._display : outgoingInvoice.customerIndividual._display}}
      </h6>
      <div class="d-flex justify-content-between text-truncate">
        <small>{{ outgoingInvoice.billingDate | moment('L') }}</small>
        <small>{{ currency(outgoingInvoice.preTaxAmount) }}</small>
      </div>
    </template>

  </generic-content>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { currency } from '@/utils/filter'
import { useOutgoingInvoices } from '../../../views/sales/outgoingInvoices/useOutgoingInvoices'

import GenericContent from './Content'

export default {
  components: {
    GenericContent
  },
  props: {
    outgoingInvoice: {
      type: Object,
      default: () => { }
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isPayable: {
      type: Boolean,
      default: false
    },
    isDeletable: {
      type: Boolean,
      default: true
    },
    isParentMethodPriority: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const iconStatus = computed(() => {
      return getOutgoingInvoiceIconStatus(props.outgoingInvoice)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const { getOutgoingInvoiceIconStatus, downloadOutgoingInvoice } = useOutgoingInvoices()

    const download = () => {
      downloadOutgoingInvoice(props.outgoingInvoice)
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      currency,

      // Data

      // Computed
      iconStatus,

      // Methods
      download,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>